/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-ypadding',
  templateUrl: './theme-option-tooltips-ypadding.component.html',
  styleUrls: ['./theme-option-tooltips-ypadding.component.css']
})
export class ThemeOptionTooltipsYPaddingComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_yPadding';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_yPadding', value);
  }

}
